import type { FunctionComponent } from "react";

import { StyledWrapper } from "./style";

export const HistoryLoader: FunctionComponent = () => {
  return (
    <StyledWrapper>
      <svg
        width="740"
        height="564"
        viewBox="0 0 740 564"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="15" y="10" width="644" height="24" rx="4" fill="#FAFAFA" />
        <rect
          opacity="0.8"
          x="15"
          y="41"
          width="558"
          height="24"
          rx="4"
          fill="#FAFAFA"
        />
        <rect
          opacity="0.6"
          x="15"
          y="72"
          width="426"
          height="24"
          rx="4"
          fill="#FAFAFA"
        />
        <rect
          opacity="0.4"
          x="15"
          y="103"
          width="610"
          height="24"
          rx="4"
          fill="#FAFAFA"
        />
      </svg>
    </StyledWrapper>
  );
};
